import GetStartedButton from "@/components/landing/GetStartedButton";
import { Sparkles } from "lucide-react";
import aelyraImg from "@/assets/instructor-aelyra.png";
import caelionImg from "@/assets/instructor-caelion.png";
import vaelorImg from "@/assets/instructor-vaelor.png";

const lumiImg = "/assets/lumi-vanta.png";

const guideChips = [
  { src: aelyraImg, ring: "ring-cyan-300/45" },
  { src: vaelorImg, ring: "ring-amber-300/45" },
  { src: caelionImg, ring: "ring-violet-300/45" },
  { src: lumiImg, ring: "ring-indigo-300/55" },
];

const CTASection = () => (
  <section className="relative py-16 sm:py-24">
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[640px] w-[640px] rounded-full bg-[radial-gradient(circle,rgba(99,102,241,0.22),transparent_60%)] blur-3xl" />
    </div>

    <div className="container mx-auto px-6 max-w-4xl relative">
      <div className="relative rounded-3xl p-[1px] bg-gradient-to-r from-cyan-400/40 via-indigo-500/35 to-violet-500/40">
        <div className="relative rounded-3xl bg-[#0e0d24]/90 backdrop-blur-2xl px-8 py-12 sm:py-16 text-center overflow-hidden">
          {/* Portal glow + rotating ring */}
          <div aria-hidden className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(139,92,246,0.22),transparent_70%)]" />
          <div aria-hidden className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[520px] w-[520px] rounded-full bg-[conic-gradient(from_0deg,transparent,rgba(34,211,238,0.22),transparent_35%,rgba(167,139,250,0.22),transparent_70%)] blur-[2px] opacity-60 animate-[spin_36s_linear_infinite]" />
          <div aria-hidden className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[380px] w-[380px] rounded-full border border-white/[0.07]" />

          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 mb-6 backdrop-blur-md">
              <span className="h-1.5 w-1.5 rounded-full bg-cyan-300 shadow-[0_0_10px_rgba(34,211,238,0.95)] animate-pulse" />
              <span className="text-[10px] uppercase tracking-[0.3em] text-white/85">Economic & Enterprise Education</span>
            </div>

            {/* Guide chip cluster */}
            <div className="flex justify-center -space-x-3 mb-7">
              {guideChips.map((g, i) => (
                <div key={i} className={`relative h-12 w-12 rounded-full overflow-hidden ring-2 ${g.ring} bg-[#0e0d24] shadow-[0_0_30px_-6px_rgba(129,140,248,0.6)]`}>
                  <img src={g.src} alt="" className="h-full w-full object-cover" />
                </div>
              ))}
            </div>

            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl text-white leading-[1.05] max-w-2xl mx-auto">
              Help your teen practice money decisions{" "}
              <span className="bg-gradient-to-r from-cyan-200 via-indigo-200 to-violet-200 bg-clip-text text-transparent">
                before life makes mistakes expensive.
              </span>
            </h2>
            <p className="mt-5 text-white/70 max-w-xl mx-auto">
              Create your account, choose a plan, complete household onboarding, and start your teen's first lesson today.
            </p>

            <div className="mt-8 flex justify-center">
              <GetStartedButton
                size="lg"
                className="h-12 px-8 bg-gradient-to-r from-cyan-400 via-indigo-500 to-violet-500 text-white border-0 shadow-[0_10px_44px_-10px_rgba(99,102,241,0.85)]"
              />
            </div>

            <div className="mt-7 flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-[11px] text-white/60">
              {[
                ["bg-emerald-400", "Plans from $24.99/mo"],
                ["bg-violet-400", "Parent-managed"],
                ["bg-cyan-400", "Ages 13+"],
                ["bg-amber-300", "Up to 4 teens on Family"],
              ].map(([dot, label]) => (
                <span key={label} className="inline-flex items-center gap-2">
                  <span className={`h-1 w-1 rounded-full ${dot}`} />
                  {label}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CTASection;